
import { useState, createContext, useContext, useEffect } from 'react'

import {
    InitSilver,
    INIT_POOLS
} from '../chain/silver'

import {useEthers} from '../ethers'
// import {
//     DEFAULT_ACCOUNT
// } from '../ethers/e'

export const Context = createContext({})

export const useSilver = () => useContext(Context)



function useSilverProvider() {
    const {account, getBlockNumber} = useEthers()
    const [data, setState] = useState(INIT_POOLS)
    // console.log(account, getBlockNumber())
    useEffect(() => {
        const init = async () => {
            setState(
                await InitSilver(account)
            )
        }
        init()
    }, [account, getBlockNumber()])
    return data
}


function SilverContext({children}) {
    const p = useSilverProvider()
    return (
        <Context.Provider
            value={p}
        >
            {children}
        </Context.Provider>
    )
}

export default SilverContext